import _ from "lodash";

const ProcessDesignerNavigation = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const CurrentGroup = props.CurrentGroup;
  const SetCurrentGroup = props.SetCurrentGroup;


  const onClickNavigation = (_data) => {

    let currentIndex = CurrentGroup.findIndex(g => g._id == _data._id);



    if (currentIndex == -1 || currentIndex == CurrentGroup.length - 1) return;

    let toUpdateGroup = _.cloneDeep(CurrentGroup);

    toUpdateGroup.length = currentIndex + 1


    SetCurrentGroup(toUpdateGroup);

  };


  return (
    <div className="processdesigner_navigation_cont">
      {CurrentGroup.map((g, index) => (
        <div className={"processdesigner_navigation_group " + (index == CurrentGroup.length - 1 ? "processdesigner_navigation_group_active" : "")} key={index} onClick={() => onClickNavigation(g)}>
          <div className="processdesigner_navigation_group_text">
            {g.title}
          </div>
        </div>
      ))}
    </div>
  );

};

export default ProcessDesignerNavigation